import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getBranchIdFromPathname, isUkBranchId } from "../../utils/apiBaseUrl";
import { useCurrentUserBranch } from "../../hooks/useCurrentUserBranch";

/**
 * LocaleManager component handles automatic locale switching based on the LLTS branch ID.
 *
 * When the branch ID is "uk" (case-insensitive), the locale is automatically switched to British English (en-GB).
 * Otherwise, the default American English (en) locale is used.
 *
 * This component renders nothing and only performs side effects.
 */
const LocaleManager: React.FC = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  const { data: userBranch } = useCurrentUserBranch();

  useEffect(() => {
    // Prefer the branch ID from the URL; fall back to the authenticated user's branch.
    const branchId = getBranchIdFromPathname(location.pathname) ?? userBranch?.id;
    const targetLocale: "en-GB" | "en" = isUkBranchId(branchId) ? "en-GB" : "en";

    // Only change language if it's different from the current language
    if (i18n.language !== targetLocale) {
      i18n.changeLanguage(targetLocale);
    }
  }, [location.pathname, i18n, userBranch?.id]);

  // This component doesn't render anything
  return null;
};

export default LocaleManager;
